import request from '@/utils/request'

//获取企业资质列表
export function qualificationList(params) {
  return request({
    url: '/api/business/qualification/list',
    method: 'get',
    params
  })
}

//获取企业资质详情
export function qualificationDetail(params) {
  return request({
    url: '/api/business/qualification/detail',
    method: 'get',
    params
  })
}

//新增更新企业资质
export function qualificationUpsert(data) {
  return request({
    url: '/api/business/qualification/upsert',
    method: 'post',
    data
  })
}

//注册资料列表--主场
export function registerInfoList(params) {
  return request({
    url: 'api/registerInfo/list',
    method: 'get',
    params
  })
}

//切换注册资料--主场
export function registerInfoSwitch(params) {
  return request({
    url: 'api/registerInfo/switch',
    method: 'post',
    params
  })
}

//注册资料详情--主场
export function registerInfoDetail(params) {
  return request({
    url: 'api/registerInfo/detail',
    method: 'get',
    params
  })
}

//提交资料--主场
export function registerInfoSubmit(params) {
  return request({
    url: 'api/registerInfo/submit',
    method: 'post',
    data:params
  })
}
//保存资料--主场
export function registerInfoSave(params) {
  return request({
    url: 'api/registerInfo/save',
    method: 'post',
    data:params
  })
}

//接受注册资料审核结果--主场
export function registerInfoAuditReceive(params) {
  return request({
    url: 'api/registerInfo/audit/receive',
    method: 'post',
    data:params
  })
}
//注册资料详情--搭建商
export function builderRegisterInfoDetail(params) {
  return request({
    url: '/api/builder/registerInfo/detail',
    method: 'get',
    params
  })
}

//提交资料--搭建商
export function builderRegisterInfoSubmit(params) {
  return request({
    url: '/api/builder/registerInfo/submit',
    method: 'post',
    data:params
  })
}